import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import styles from './PageHolder.scss';
import StatusBar from '../../shared/StatusBar/StatusBar';

const cx = classNames.bind(styles);

const TYPES = {
  // SMALL: 'small',
  SIDE_MENU: 'side-menu', // Desktop
  SIDE_BAR: 'side-bar', // Desktop
  SIDE_PANEL: 'large',
  FULL_WIDTH_MOBILE: 'full-width-mobile', // Used to force some pages to full width on mobile
  FULL_WIDTH: 'full-width',
  FLOATING_PANEL: 'floating-panel',
};

const PageHolder = (props) => {
  const {
    className,
    showingPageHolder,
    pageHolderType,
    pageHolderTransparent,
    pageHolderElevation,
    appViewportSize,
    children,
  } = props;

  // const pageHolderStyle = {
  //   // width: 100%,
  // };

  const viewClasses = cx('page-holder', {
    [`page-holder--type-${pageHolderType}`]: pageHolderType,
    'page-holder--hide': !showingPageHolder,
    'page-holder--transparent': pageHolderTransparent,
    'page-holder--has-elevation': pageHolderElevation,
    [className]: className,
  });

  return (
    <>
      <div
        id="pageHolder"
        className={viewClasses}
        style={{
          minHeight:
            appViewportSize.height > 0
              ? `${appViewportSize.height}px`
              : '100vh',
          maxHeight:
            appViewportSize.height > 0
              ? `${appViewportSize.height}px`
              : '100vh',
          height:
            appViewportSize.height > 0
              ? `${appViewportSize.height}px`
              : '100vh',
        }}
      >
        <StatusBar show={showingPageHolder} />
        {children}
      </div>
    </>
  );
};

PageHolder.propTypes = {
  showingPageHolder: PropTypes.bool.isRequired,
  pageHolderTransparent: PropTypes.bool.isRequired,
  pageHolderElevation: PropTypes.bool.isRequired,
  appViewportSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,

  /** Type of button to use */
  pageHolderType: PropTypes.oneOf(Object.values(TYPES)),

  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  className: PropTypes.string,
};

PageHolder.defaultProps = {
  pageHolderType: TYPES.SIDE_BAR,
  children: null,
  className: null,
};

const mapDispatchToProps = () => ({});

const mapStateToProps = (state) => ({
  showingPageHolder: state.appControls.showingPageHolder,
  pageHolderType: state.appControls.pageHolderType,
  pageHolderTransparent: state.appControls.pageHolderTransparent,
  pageHolderElevation: state.appControls.pageHolderElevation,

  appViewportSize: state.appControls.appViewportSize,
});

/** Export our pageHolderSizes sizing constants */
PageHolder.types = TYPES;
// PageHolder.widths = WIDTHS;

export default connect(mapStateToProps, mapDispatchToProps)(PageHolder);
